var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ZG0cm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12ZM17.8 9.8C18.2 10.2 18.2 10.8 17.8 11.2L13 15.9C12.3 16.6 11.6 16.6 11 15.9L6.3 11.1C5.9 10.7 5.9 10.1 6.3 9.7C6.7 9.3 7.3 9.3 7.7 9.7L11.9 13.9C12 14 12.1 14 12.2 13.9L16.4 9.7C16.7 9.4 17.4 9.4 17.8 9.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCircleArrow);
export default __webpack_public_path__ + "static/media/filledCircleArrow.311b4466075c920e54bc39e721504e95.svg";
export { ForwardRef as ReactComponent };